(ns core.gis.arcgis.model)

(def number-field-types
  #{"esriFieldTypeOID"
    "esriFieldTypeInteger"
    "esriFieldTypeSmallInteger"
    "esriFieldTypeDouble"})

(defn number-field-type?
  "Check if the field type is a numeric type that should not be quoted in SQL,
  including both integer and decimal number types."
  [field-type]
  (contains? number-field-types field-type))
